// Shared types for Fund form pages

export interface FundFormData {
  name: string;
  display_name: string;
  fund_type: string;
  legal_structure: string;
  domicile_country: string;
  base_currency: string;
  minimum_prepayment_pool: number | null;
  target_size: number | null;
  hard_cap: number | null;
  first_closing_date: string;
  final_closing_date: string;
  fund_term_years: string;
  extension_periods: string;
  vintage_year: string;
  status: string;
  lei_code: string;
  tax_id: string;
  coc_number: string;
  regulatory_regime: string;
  accounting_framework: string;
  lp_allocation_mode: string;
  // LPA Terms
  management_fee_investment_period: string;
  management_fee_post_investment: string;
  management_fee_basis_investment: string;
  management_fee_basis_post_investment: string;
  gp_commitment: string;
  waterfall_type: string;
  hurdle_rate: string;
  gp_catch_up: string;
  carried_interest: string;
  investment_period_years: string;
  fund_costs_cap: string;
  // Fund relationships
  parent_fund_id: string;
  master_fund_id: string;
}

export interface BankAccountFormData {
  id: string;
  account_name: string;
  account_type: string;
  bank_name: string;
  iban: string;
  swift_bic: string;
  account_number: string;
  currency: string;
  is_primary: boolean;
}

export interface FundEntityFormData {
  id: string;
  entity_name: string;
  role: string;
  jurisdiction: string;
  registration_number: string;
  iban: string;
}

export const initialFormData: FundFormData = {
  name: '',
  display_name: '',
  fund_type: 'main',
  legal_structure: '',
  domicile_country: 'NLD',
  base_currency: 'EUR',
  minimum_prepayment_pool: null,
  target_size: null,
  hard_cap: null,
  first_closing_date: '',
  final_closing_date: '',
  fund_term_years: '10',
  extension_periods: '2',
  vintage_year: new Date().getFullYear().toString(),
  status: 'setup',
  lei_code: '',
  tax_id: '',
  coc_number: '',
  regulatory_regime: 'aifmd',
  accounting_framework: 'RJ',
  lp_allocation_mode: 'PRO_RATA',
  // LPA Terms defaults
  management_fee_investment_period: '2.0',
  management_fee_post_investment: '1.5',
  management_fee_basis_investment: '',
  management_fee_basis_post_investment: '',
  gp_commitment: '',
  waterfall_type: '',
  hurdle_rate: '8.0',
  gp_catch_up: '100',
  carried_interest: '20.0',
  investment_period_years: '5',
  fund_costs_cap: '',
  // Fund relationships
  parent_fund_id: 'none',
  master_fund_id: 'none',
};

// Extended error type for API responses with nested structure
export interface ApiErrorResponse extends Error {
  response?: {
    data?: {
      detail?: string;
    };
  };
}
